import BulkAction from '../components/BulkAction'
import N2StylesModal from '../components/N2StylesModal'

export default class PublicationJobsEmailSubscriptions {
  constructor(params) {
    this.params = params;
  }

  index() {
    new BulkAction({
      target: "#emails-bulk-store",
      action: "#emails-bulk-action",
      secondary_nav: "#emails-action-bar",
      checked_scope: "td",
    })

    new N2Styles.searchBar({
      safeContainer: '.js-table-search',
      showSelector: '.show-table-search',
      visible: this.params['search'],
    });

    this.registerSwitch()
    this.registerListeners()
  }

  registerSwitch() {
    N2.handle("change", '.js-change-preview-status', (evt) => {
      let active = $(evt.currentTarget).prop('checked')

      $.ajax({
        type: "PUT",
        url: $(evt.currentTarget).data('url'),
        data: {n2_email_campaign: {active: active}},
        success: function(resp) {
          let status = resp.active == false ? "inactive" : "active"
          $(".js-pub-preview-status").html(status)
        },
        error: function(resp) {
          toastr.options["positionClass"] = "toast-bottom-center";
          toastr["info"]("Something has gone wrong. Please try again soon.");
        }
      });
    })
  }

  registerListeners() {
    N2.handle("click", '.js-show-emails-delete-modal', (evt) => {
      new N2StylesModal('.js-emails-delete-modal')
    })

    // Button in the modal
    N2.handle("click", '.js-confirm-bulk-delete', (evt) => {
      $('.js-show-emails-delete-modal').closest('form').submit();
    })
  }
}
